var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('page-title',{attrs:{"title":"post"}},[_c('v-btn',{attrs:{"slot":"before","icon":""},slot:"before"},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("mdi-arrow-left-thick")])],1)],1),_vm._v(" "+_vm._s(_vm.post)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }